export enum RichTextAction {
  Bold = 'bold',
  Italics = 'italic',
  Underline = 'underline',
  LeftAlign = 'left',
  CenterAlign = 'center',
  RightAlign = 'right',
  Color = 'black',
}
